import { useState } from 'react';
import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import VideoGallery from './components/VideoGallery';
import PhotoCarousel from './components/PhotoCarousel';
import StatsCards from './components/StatsCards';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function Home() {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50">
      <Hero />
      <AboutMe />
      <VideoGallery activeVideo={activeVideo} setActiveVideo={setActiveVideo} />
      <PhotoCarousel />
      <StatsCards />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
}
